import { ICON_TYPES } from '../constants';

export const ArrowLeftIcon = (): JSX.Element => {
  return (
    <svg viewBox="0 0 25 40" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.33333 20L24.6667 35.3333L20 40L0 20L20 9.53674e-07L24.6667 4.66667L9.33333 20Z" />
    </svg>
  );
};

ArrowLeftIcon.iconType = ICON_TYPES.ARROW_LEFT;
